export default function (state, value) {
    state.tab = value ? value : 'form';
}